import { Button, Input, type NumberFieldProps } from 'react-aria-components';
import * as Styled from './NumberInput.styled';
import Minus from '@/assets/icons/Minus.svg';
import Plus from '@/assets/icons/Plus.svg';
import Trash from '@/assets/icons/Trash.svg';

interface NumberInputProps extends NumberFieldProps {
  canDelete?: boolean;
  label: string;
  maxValue: number;
  minValue?: number;
  value: number;
}

export const NumberInput = ({
  canDelete = false,
  label,
  maxValue,
  minValue = 0,
  onChange,
  value,
}: NumberInputProps) => {
  const isDeletable = value === minValue + 1 && canDelete;

  return (
    <Styled.Field
      aria-label={label}
      decrementAriaLabel={isDeletable ? 'Delete' : undefined}
      defaultValue={value}
      minValue={minValue}
      maxValue={maxValue}
      onChange={onChange}
    >
      <Styled.Group>
        <Button slot="decrement">
          {isDeletable ? <Trash data-icon="trash" /> : <Minus />}
        </Button>
        <Input />
        <Button slot="increment">
          <Plus />
        </Button>
      </Styled.Group>
    </Styled.Field>
  );
};
